import ConfirmationPage from "./ConfirmationPage";

export default ConfirmationPage;
